<template lang="pug">
b-modal#updateCommAffiliate(
  ref="updateCommAffiliate"
  :title="$t('ui.combine.update_comm')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.account_id')" disabled).mb-0
      DebounceInput(
        size="sm"
        ref="account_id"
        required
        type="text"
        :dirty="$v.account_id.$dirty"
        :error="$v.account_id.$error"
        v-model.trim.lazy="$v.account_id.$model"
        :disabled="loading"
        :maxLength="$v.account_id.$params.maxLength.max"
      )
      ValidateResult(:value="$v.account_id" :name="$t('ui.account_id')")
    b-form-group(:label="$t('ui.comm_sports')").mb-0
      b-form-select(
        size="sm"
        :dirty="$v.comm_sports.$dirty"
        :error="$v.comm_sports.$error"
        v-model.trim.lazy="$v.comm_sports.$model"
      )
        option(v-for="opt in commSportsOpt" :value="opt.value") {{ opt.text }}
      ValidateResult(:value="$v.comm_sports" :name="$t('ui.comm_sports')")
    b-form-group(:label="$t('ui.comm_slots')").mb-0
      b-form-select(
        size="sm"
        :dirty="$v.comm_slots.$dirty"
        :error="$v.comm_slots.$error"
        v-model.trim.lazy="$v.comm_slots.$model"
      )
        option(v-for="opt in commSlotsOpt" :value="opt.value") {{ opt.text }}
      ValidateResult(:value="$v.comm_slots" :name="$t('ui.comm_slots')")
    b-form-group(:label="$t('ui.comm_livecasino')").mb-0
      b-form-select(
        size="sm"
        :dirty="$v.comm_livecasino.$dirty"
        :error="$v.comm_livecasino.$error"
        v-model.trim.lazy="$v.comm_livecasino.$model"
      )
        option(v-for="opt in commLivecasinoOpt" :value="opt.value") {{ opt.text }}
      ValidateResult(:value="$v.comm_livecasino" :name="$t('ui.comm_livecasino')")
    b-form-group(:label="$t('ui.comm_cockfight')").mb-0
      b-form-select(
        size="sm"
        :dirty="$v.comm_cockfight.$dirty"
        :error="$v.comm_cockfight.$error"
        v-model.trim.lazy="$v.comm_cockfight.$model"
      )
        option(v-for="opt in commCockfightOpt" :value="opt.value") {{ opt.text }}
      ValidateResult(:value="$v.comm_cockfight" :name="$t('ui.comm_cockfight')")
    b-form-group(:label="$t('ui.comm_others')").mb-0
      b-form-select(
        size="sm"
        :dirty="$v.comm_others.$dirty"
        :error="$v.comm_others.$error"
        v-model.trim.lazy="$v.comm_others.$model"
      )
        option(v-for="opt in commOthersOpt" :value="opt.value") {{ opt.text }}
      ValidateResult(:value="$v.comm_others" :name="$t('ui.comm_others')")
    //- div.row
    //-   div.col
    //-     b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, maxValue, minLength, maxLength, integer, numeric, helpers, decimal } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
    operatorID: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      account_id: "",
      account_type: 1,
      parent_id: "",
      comm_sports: 0,
      comm_slots: 0,
      comm_livecasino: 0,
      comm_cockfight: 0,
      comm_others: 0,
      upline_comm_sports: 0,
      upline_comm_slots: 0,
      upline_comm_livecasino: 0,
      upline_comm_cockfight: 0,
      upline_comm_others: 0,
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      commOpt: [],
    };
  },
  computed: {
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
    commSportsOpt() {
      if (this.account_type != 1)
        return this.commOpt.filter(d => { return d.value <= this.upline_comm_sports });
      else
        return this.commOpt;
    },
    commSlotsOpt() {
      if (this.account_type != 1)
        return this.commOpt.filter(d => { return d.value <= this.upline_comm_slots });
      else
        return this.commOpt;
    },
    commLivecasinoOpt() {
      if (this.account_type != 1)
        return this.commOpt.filter(d => { return d.value <= this.upline_comm_livecasino });
      else
        return this.commOpt;
    },
    commCockfightOpt() {
      if (this.account_type != 1)
        return this.commOpt.filter(d => { return d.value <= this.upline_comm_cockfight });
      else
        return this.commOpt;
    },
    commOthersOpt() {
      if (this.account_type != 1)
        return this.commOpt.filter(d => { return d.value <= this.upline_comm_others });
      else
        return this.commOpt;
    },
  },
  validations: {
    account_id: {
      required,
      maxLength: maxLength(50)
    },
    comm_sports: {
      required,
      maxValue: maxValue(80)
    },
    comm_slots: {
      required,
      maxValue: maxValue(80)
    },
    comm_livecasino: {
      required,
      maxValue: maxValue(80)
    },
    comm_cockfight: {
      required,
      maxValue: maxValue(80)
    },
    comm_others: {
      required,
      maxValue: maxValue(80)
    },
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.commissionUpdateAffUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.isOperator ? this.accountID : this.operatorID,
          account_id: this.account_id,
          comm_sports: this.comm_sports,
          comm_slots: this.comm_slots,
          comm_livecasino: this.comm_livecasino,
          comm_cockfight: this.comm_cockfight,
          comm_others: this.comm_others,
          audit_by: this.$store.getters.loginId
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.updateCommAffiliate.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "update_comm", this.feedback.status);
                  this.$refs.updateCommAffiliate.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    getCommLookup: function() {
      for (var i = 0; i <= 100; i+= 1) {
        this.commOpt.push({value: i, text: i + '%'});
      }
    },
    getUplineComm: function() {
      let url = config.commissionGetAffUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.isOperator ? this.accountID : this.operatorID,
        account_id: this.parent_id
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if (response.data.dt.length > 0) {
                  this.upline_comm_sports = response.data.dt[0]['sports'];
                  this.upline_comm_slots = response.data.dt[0]['slots'];
                  this.upline_comm_livecasino = response.data.dt[0]['livecasino'];
                  this.upline_comm_cockfight = response.data.dt[0]['cockfight'];
                  this.upline_comm_others = response.data.dt[0]['others'];
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getAffiliateComm: function() {
      let url = config.commissionGetAffUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.isOperator ? this.accountID : this.operatorID,
        account_id: this.account_id
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if (response.data.dt.length > 0) {
                  this.comm_sports = response.data.dt[0]['sports'];
                  this.comm_slots = response.data.dt[0]['slots'];
                  this.comm_livecasino = response.data.dt[0]['livecasino'];
                  this.comm_cockfight = response.data.dt[0]['cockfight'];
                  this.comm_others = response.data.dt[0]['others'];
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.account_id = this.item.account_id;
      this.account_type = this.item.account_type;
      this.parent_id = this.item.parent_id;
      this.commOpt = [];
      this.getCommLookup();
      // console.log(this.account_type)
      if (this.account_type != 1) {
        this.getUplineComm();
      }
      this.getAffiliateComm();
      // this.$refs.comm_package.$el.focus();
    }
  }
};
</script>
